import { Link, useLocation } from 'react-router-dom'
import { Heart, ShoppingBag, Radio, User, LayoutGrid } from 'lucide-react'
import { vibrate } from '../../utils/appPrefs'

/**
 * Barre de navigation du bas (téléphone).
 * Remplace l'ancien bouton hamburger + menu plein écran :
 * les 4 destinations les plus utilisées sont à portée de pouce,
 * tout le reste est dans la feuille "Plus".
 */
function Item({ to, icon: Icon, label, pathname }) {
  const active = pathname === to
  return (
    <Link
      to={to}
      className={`j-nav__item ${active ? 'is-active' : ''}`}
      aria-current={active ? 'page' : undefined}
      onClick={() => vibrate(8)}
    >
      <Icon strokeWidth={active ? 2.4 : 2} />
      <span>{label}</span>
    </Link>
  )
}

function DockBar({ onMoreClick, moreOpen = false, isPlaying = false }) {
  const { pathname } = useLocation()

  return (
    <nav className="j-nav" aria-label="Navigation principale">
      <div className="j-nav__bar">
        <Item to="/dedicaces" icon={Heart} label="Dédicaces" pathname={pathname} />
        <Item to="/boutique" icon={ShoppingBag} label="Boutique" pathname={pathname} />

        <Link
          to="/"
          className="j-nav__radio"
          aria-label={isPlaying ? 'Radio — en lecture' : 'Radio'}
          aria-current={pathname === '/' ? 'page' : undefined}
          onClick={() => vibrate(12)}
        >
          {isPlaying ? (
            <span className="j-eq" aria-hidden="true">
              <span /><span /><span /><span />
            </span>
          ) : (
            <Radio strokeWidth={2.4} />
          )}
          <span className="j-nav__radio-label">Radio</span>
        </Link>

        <Item to="/profile" icon={User} label="Profil" pathname={pathname} />

        <button
          type="button"
          className={`j-nav__item ${moreOpen ? 'is-active' : ''}`}
          onClick={() => { vibrate(8); onMoreClick?.() }}
          aria-haspopup="dialog"
          aria-expanded={moreOpen}
        >
          <LayoutGrid strokeWidth={moreOpen ? 2.4 : 2} />
          <span>Plus</span>
        </button>
      </div>
    </nav>
  )
}

export default DockBar
